<template>
  <v-layout class="d-flex justify-center"
            v-if="!$store.state.isPremiumUser"
  >
    <Adsense
      v-if="rootPath == 'https://alpaca-connect.com'"
      data-ad-client="ca-pub-1075252583495026"
      data-ad-slot="8002978834"
      :ins-style="
        $vuetify.breakpoint.xsOnly
          ? 'display:inline-block;width:320px;height:100px'
          : $vuetify.breakpoint.smAndDown
          ? 'display:inline-block;width:460px;height:60px'
          : 'display:inline-block;width:728px;height:90px'
      "
    ></Adsense>

    <v-sheet
      color="#eee"
      v-else
      :height="
        $vuetify.breakpoint.xsOnly
          ? 100
          : $vuetify.breakpoint.smAndDown
          ? 60
          : 90
      "
      :width="
        $vuetify.breakpoint.xsOnly
          ? 320
          : $vuetify.breakpoint.smAndDown
          ? 460
          : 728
      "
      class="d-flex justify-center align-center"
    >
      add01
    </v-sheet>
  </v-layout>
</template>

<script>
export default {
  name: "Add01",

  /*

    */
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";
</style>
